module.exports = __webpack_public_path__ + "img/clearable.d89272bb.png";